import React, { ReactNode } from 'react'
import { Redirect, RouteComponentProps } from 'react-router-dom'

import { RouteGuardRenderProps, RouteLocationState } from './types'
import { buildComponentTree, createComponentTreeMap } from './utils'

type RenderRouteFn = (args: RouteGuardRenderProps) => (props: RouteComponentProps<any>) => ReactNode

export const renderRoute: RenderRouteFn = ({ component: Cmp, guards, canActivate, redirectTo }) => (props) => {
  if (guards) {
    const guardsWithComponent = [...guards, Cmp]
    const treeMap = createComponentTreeMap(guardsWithComponent, props)
    const tree = buildComponentTree(treeMap!)

    return tree
  }

  if (canActivate) {
    return handleCanActivate()
  }

  function handleCanActivate() {
    const willActivate = canActivate!(props)
    const routerState: RouteLocationState = { from: props.location.pathname }

    return willActivate ? (
      <Cmp {...props} />
    ) : (
      redirectTo && (
        <Redirect
          to={{
            pathname: redirectTo,
            state: routerState,
          }}
        />
      )
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/router/guarded-route.helpers.tsx